"use strict";
/*
Human Check: the bot gate in front of every sign-in and sign-up.

The web app runs an invisible reCAPTCHA Enterprise score check while the login page is open and trades the
token for a short-lived, single-use Human Check Pass (`verifyHuman` callable). When the score check fails,
errors, or has not finished, the next auth click opens a dialog with a checkbox challenge instead. The pass
rides along to `captureSignInData`, which only grants the signup trial against a verified, unused pass.

Site keys are public (they ship in the web bundle), so they live here where web and functions share them.
Both keys are reCAPTCHA Enterprise keys in the image-ai-cb35d Google Cloud project: one score-based
(invisible) and one checkbox (the challenge). Leave a key empty and that half of the gate stays inert, and the
server never enforces while either key is missing.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HUMAN_CHECK_PASS_TTL_MINUTES = exports.HUMAN_CHECK_ACTION = exports.HUMAN_CHECK_HOSTNAMES = exports.RECAPTCHA_CHALLENGE_SITE_KEY = exports.RECAPTCHA_SCORE_SITE_KEY = void 0;
// "App login - score" in the reCAPTCHA console: score-based, app.rundiffusion.com only
exports.RECAPTCHA_SCORE_SITE_KEY = '6LeX19QtAAAAAANLC7Z3In8gCCuZUWMyM-X7gXsE';
// "App login - checkbox" in the reCAPTCHA console: checkbox challenge, app.rundiffusion.com only
exports.RECAPTCHA_CHALLENGE_SITE_KEY = '6LcMr9QtAAAAACVHKrvEhGgX1CzkLkoIJMzJnq1x';
// Where the keys work: keep this in sync with both keys' domain lists in the reCAPTCHA console. Anywhere else
// (localhost, Firebase preview channels) the checkbox cannot even render, so the web app leaves the gate off
// there instead of trapping people at a challenge they cannot pass. The server still withholds the signup trial
// from any first sign-in without a verified pass, whatever host it came from.
exports.HUMAN_CHECK_HOSTNAMES = ['app.rundiffusion.com'];
// The action name the score token is minted for; the server rejects a token minted for anything else.
exports.HUMAN_CHECK_ACTION = 'auth';
// A pass outlives the page refresh interval (10 min) with room for a slow OAuth popup before captureSignInData.
exports.HUMAN_CHECK_PASS_TTL_MINUTES = 30;
